/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';

export class CheckboxButton extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { innerCss = {} } = props;
    return (
      <label css={[styles.label, innerCss.container]} htmlFor={props.id}>
        <input
          type="checkbox"
          id={props.id}
          name={props.id}
          checked={props.checked}
          onChange={props.onChange}
        />
        <span>{props.children}</span>
      </label>
    );
  }
}

CheckboxButton.displayName = 'CheckboxButton';

CheckboxButton.defaultProps = {};

CheckboxButton.propTypes = {};

export default compose(withSitecoreContext())(CheckboxButton);
